var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.089 18.306a2.985 2.985 0 0 1 1.049-1.641.99.99 0 0 0-.242-.18L8.14 12.37a.952.952 0 0 0-.173-.042 2.983 2.983 0 0 1-.812 1.753.95.95 0 0 0 .134.1l8.756 4.119c.015 0 .03 0 .044.006Zm.001-12.613c-.016.006-.03 0-.045.011L7.287 9.82a1 1 0 0 0-.133.1c.454.474.74 1.085.812 1.737l.015.009a.755.755 0 0 0 .155-.035L16.9 7.515c.09-.048.17-.108.242-.18a2.978 2.978 0 0 1-1.053-1.642Z",
    fill: "rgb(var(--tw-color-primary-200))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: "rgb(var(--tw-color-primary-900))"
  })));
};
export default SvgShare;